module.exports = "../dist/img/upper-banner-25.eee5.jpg";